<template>
  <div class="detail-container">
    <div class="detail-bread-crumb-div">
      <ZD-bread-crumb :bConfigList="breadCrumb"></ZD-bread-crumb>
    </div>
    <div class="detail-content-div">
      <div class="detail-content-header-div flex">
        <div class="left-page-title-div flex-1">{{ pageTitle }}</div>
      </div>

      <div class="detail-content-body-div flex-1">
        <el-tabs v-model="activeTab">
          <el-tab-pane label="订单信息" name="order">
            <OrderInfo :form="form" :areaSelectKey="areaSelectKey" @updateArea="updateAreaSelection" @goBack="goBack" />
          </el-tab-pane>

          <el-tab-pane label="流量服务信息" name="flow">
            <FlowServiceInfo :flowSummary="flowSummary" :flowBills="flowBills" />
          </el-tab-pane>

          <el-tab-pane label="解约/买断申请记录" name="terminate">
            <TerminateRecord :activityOrderNo="form.activityOrderNo" :terminateSummary="terminateSummary" />
          </el-tab-pane>
        </el-tabs>

        <div class="bottom-actions">
          <el-button type="primary" @click="onSave" v-if="activeTab === 'order'">保存</el-button>
          <el-button @click="goBack">返回</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import OrderInfo from './OrderInfo.vue';
import FlowServiceInfo from './FlowServiceInfo.vue';
import TerminateRecord from './TerminateRecord.vue';

export default {
  name: "EmptySwitchActivityDetail",
  components: {
    OrderInfo,
    FlowServiceInfo,
    TerminateRecord,
  },
  data() {
    return {
      pageTitle: "空开活动详情",
      areaSelectKey: 0,
      activeTab: "order",
      breadCrumb: [
        { name: "营销活动" },
        { name: "空开&送桩活动" },
        { name: "订单详情" },
      ],
      form: {
        buyName: "",
        createTime: "",
        activityOrderNo: "",
        relationGoodsOrderNo: "",
        userName: "",
        userMobile: "",
        orderStatusText: "",
        flowServiceStatusText: "",
        deviceBindTime: "",
        switchDeviceNo: "",
        switchDeviceAssetNo: "",
        pileDeviceNo: "",
        pileDeviceAssetNo: "",
        pileInstallCompleteTime: "",
        mainServiceOrderNo: "",
        memberServiceStatusText: "",
        memberServiceTotalPaid: "",
        memberServiceUsedMonths: "",
        terminateTypeText: "",
        terminateApplyTime: "",
        terminateCompleteTime: "",
        terminateReason: "",
        buyoutTypeText: "",
        buyoutCompleteTime: "",
        isViolationBuyoutText: "",
        violationBuyoutReason: "",
        buyoutFreeDepositAmount: "",
        activityOrderOriginPrice: "",
        zhimaCreditStatusText: "",
        subsidyEligibleText: "",
        province: "",
        city: "",
        area: "",
        detailAddress: "",
        remark: "",
        agentName: "",
        agentPhone: "",
        agentLevel: "",
        parentAgentName: "",
      },
      flowSummary: {
        totalUsed: "",
        totalPaid: "",
        chargingStandards: "",
        currentStatus: "",
        periodStart: "",
        periodEnd: "",
        remainDays: "",
      },
      flowBills: [],
      terminateSummary: {
        terminateType: "",
        terminateReason: "",
        applyTime: "",
        completeTime: "",
        refundAmount: "",
        payableAmount: "",
      },
      terminateRecords: [],
      activityOrderId: "", // 活动订单ID，用于流量统计等接口（来自详情接口 / list）
    };
  },
  watch: {
    "$route.query"(val) {
      if (val.activityOrderNo) {
        this.form.activityOrderNo = val.activityOrderNo;
        this.loadDetailData();
      }
    },
  },
  mounted() {
    this.form.activityOrderNo = this.$route.query.activityOrderNo || "";
    if (this.form.activityOrderNo) {
      this.loadDetailData();
    } else {
      this.$message.warning("缺少订单编号参数");
    }
  },
  methods: {
    loadDetailData() {
      if (!this.form.activityOrderNo) {
        this.$message.error("缺少订单编号参数");
        return;
      }
      this.$U.showLoading(this);
      const params = {
        activityOrderNo: this.form.activityOrderNo,
        activityExtendTypeEnum: "CIRCUIT_BREAKER_ACTIVITY",
      };
      this.$H
        .post(this, this.$A.activityOrder.circuitBreakerActivityGet, params)
        .then((res) => {
          const data = res?.data?.data || res?.data || {};
          if (res?.data?.status === 200 || res?.data?.data) {
            // 接口字段 -> form 字段映射（与 list 及接口返回一致）
            const formMap = {
              purchaseName: "buyName",
              createdWhen: "createTime",
              activityOrderNo: "activityOrderNo",
              mapNo: "relationGoodsOrderNo",
              name: "userName",
              mobile: "userMobile",
              activityOrderStatusName: "orderStatusText",
              bindTime: "deviceBindTime",
              pileCode: "pileDeviceNo",
              pileAssetCode: "pileDeviceAssetNo",
              pileInstallCompletedTime: "pileInstallCompleteTime",
              pileInstallOrderNo: "mainServiceOrderNo",
              cancelRequestTime: "terminateApplyTime",
              cancelFinishTime: "terminateCompleteTime",
              cancelReason: "terminateReason",
              refundCancelReason: "terminateReason", // 解约原因（与 cancelReason 二选一或并存，后赋优先）
              refundReasonTypeName: "terminateTypeText", // 解约类型名称
              buyoutReasonTypeName: "buyoutTypeText", // 买断类型名称
              buyOutCancelFinishTime: "buyoutCompleteTime", // 买断完成时间
              province: "province",
              city: "city",
              area: "area",
              address: "detailAddress",
              remark: "remark",
              agentName: "agentName",
              agentPhone: "agentPhone",
              agentLevel: "agentLevel",
              parentAgentName: "parentAgentName",
            };
            Object.keys(formMap).forEach((apiKey) => {
              const formKey = formMap[apiKey];
              if (data[apiKey] !== null && data[apiKey] !== undefined) {
                this.form[formKey] = data[apiKey];
              }
            });
            // 同时映射到 OrderInfo 使用的字段名
            if (data.refundReasonTypeName !== null && data.refundReasonTypeName !== undefined) {
              this.form.refundReasonTypeName = data.refundReasonTypeName;
            }
            if (data.buyoutReasonTypeName !== null && data.buyoutReasonTypeName !== undefined) {
              this.form.buyoutReasonTypeName = data.buyoutReasonTypeName;
            }
            if (data.buyOutCancelFinishTime !== null && data.buyOutCancelFinishTime !== undefined) {
              this.form.buyOutCancelFinishTime = data.buyOutCancelFinishTime;
            }
            if (data.cancelRequestTime !== null && data.cancelRequestTime !== undefined) {
              this.form.cancelRequestTime = data.cancelRequestTime;
            }
            if (data.cancelFinishTime !== null && data.cancelFinishTime !== undefined) {
              this.form.terminateCompleteTime = data.cancelFinishTime;
            }
            if (data.refundCancelReason !== null && data.refundCancelReason !== undefined) {
              this.form.refundCancelReason = data.refundCancelReason;
            }
            if (data.pileCode !== null && data.pileCode !== undefined) {
              this.form.pileCode = data.pileCode;
            }
            if (data.pileAssetCode !== null && data.pileAssetCode !== undefined) {
              this.form.pileAssetCode = data.pileAssetCode;
            }
            if (data.actualAmountStatusName !== null && data.actualAmountStatusName !== undefined) {
              this.form.actualAmountStatusName = data.actualAmountStatusName;
            }
            if (data.isEndDisbursement !== null && data.isEndDisbursement !== undefined) {
              this.form.isEndDisbursement = data.isEndDisbursement;
            }
            if (data.isViolationBuyout !== null && data.isViolationBuyout !== undefined) {
              this.form.isViolationBuyout = data.isViolationBuyout;
            }
            if (data.activityOrderOriginPrice != null && data.activityOrderOriginPrice !== undefined) {
              this.form.activityOrderOriginPrice = data.activityOrderOriginPrice;
            }
            if (data.activityOrderId != null && data.activityOrderId !== "") {
              this.activityOrderId = data.activityOrderId;
            }
            // 空开设备编号同时赋给 switch 展示
            if (data.pileCode != null && data.pileCode !== "") {
              this.form.switchDeviceNo = data.pileCode;
            }
            if (data.pileAssetCode != null && data.pileAssetCode !== "") {
              this.form.switchDeviceAssetNo = data.pileAssetCode;
            }
            if (data.flowSummary) {
              Object.assign(this.flowSummary, data.flowSummary);
            }
            if (Array.isArray(data.flowBills)) {
              this.flowBills = data.flowBills;
            }
            if (data.flowInfo) {
              Object.assign(this.flowSummary, data.flowInfo);
            }
            if (this.activityOrderId) {
              this.loadTrafficStatistics();
              this.loadTrafficBills();
            }
            if (data.terminateSummary) {
              Object.assign(this.terminateSummary, data.terminateSummary);
            }
            if (Array.isArray(data.terminateRecords)) {
              this.terminateRecords = data.terminateRecords;
            }
            // 解约/买断信息从主数据带出
            if (data.cancelRequestTime) {
              this.terminateSummary.applyTime = data.cancelRequestTime;
            }
            if (data.cancelFinishTime) {
              this.terminateSummary.completeTime = data.cancelFinishTime;
            }
            if (data.refundCancelReason != null && data.refundCancelReason !== "") {
              this.terminateSummary.terminateReason = data.refundCancelReason;
            } else if (data.cancelReason != null && data.cancelReason !== "") {
              this.terminateSummary.terminateReason = data.cancelReason;
            }
            if (data.cancelAmount != null && data.cancelAmount !== "") {
              this.terminateSummary.refundAmount = data.cancelAmount;
            }
            if (data.cancelPayableAmount != null && data.cancelPayableAmount !== "") {
              this.terminateSummary.payableAmount = data.cancelPayableAmount;
            }
            this.$nextTick(() => {
              this.areaSelectKey += 1;
            });
          } else {
            this.$message.error(res?.data?.message || res?.data?.msg || "获取详情失败");
          }
        })
        .catch(() => {
          this.$message.error("获取详情失败");
        })
        .finally(() => {
          this.$U.hideLoading(this);
        });
    },
    loadTrafficStatistics() {
      if (!this.activityOrderId) return;
      this.$H
        .post(this, this.$A.activityOrder.trafficStatistics, { activityOrderId: this.activityOrderId })
        .then((res) => {
          const data = res?.data?.data || res?.data || {};
          if (res?.data?.status === 200 || res?.data?.data) {
            const info = data;
            const statusMap = {
              TO_EXPRIRED: "即将到期",
              EXPIRED: "已过期",
              TO_ACTIVE: "待激活",
              ACTIVE: "正常",
              IN_ACTIVE: "正常",
              EXPIRING_SOON: "即将到期",
              CANCELLED: "已解约（买断）",
              IN_EXPIRED: "已解约(到期)",
            };
            this.flowSummary.totalUsed = info.dayOfUse != null && info.dayOfUse !== "" ? `${info.dayOfUse}月` : "";
            this.flowSummary.totalPaid = info.accumulatedPayments != null && info.accumulatedPayments !== "" ? `${info.accumulatedPayments}元` : "";
            this.flowSummary.chargingStandards = (info.chargingStandards != null && info.chargingStandards !== "") ? `${info.chargingStandards}元` : "";
            this.flowSummary.currentStatus = statusMap[info.recordStatus] || info.recordStatus || "";
            this.flowSummary.periodStart = info.startTime || "";
            this.flowSummary.periodEnd = info.endTime || "";
            this.flowSummary.remainDays = info.daysRemaining != null && info.daysRemaining !== "" ? `${info.daysRemaining}天` : "";
          }
        })
        .catch(() => { });
    },
    loadTrafficBills() {
      if (!this.form.activityOrderNo && !this.activityOrderId) return;
      const params = {
        activityOrderNo: this.form.activityOrderNo || this.activityOrderId,
        pageNum: 1,
        pageSize: 10,
      };
      if (this.$store?.state?.corpNo) {
        params.corpNo = this.$store.state.corpNo;
      }
      this.$H
        .post(this, this.$A.activityOrder.circuitBreakerActivityTrafficBillsPage, params)
        .then((res) => {
          const data = res?.data?.data || res?.data || {};
          if (res?.data?.status === 200) {
            const list = data.content || data.list || data.records || [];
            this.flowBills = Array.isArray(list) ? list : [];
          }
        })
        .catch(() => { });
    },
    goBack() {
      this.$router.back();
    },
    onSave() {
      if (!this.form.activityOrderNo) {
        this.$message.error("缺少订单编号");
        return;
      }
      const updateParams = {
        activityOrderNo: this.form.activityOrderNo,
        agentName: this.form.agentName || "",
        agentPhone: this.form.agentPhone || "",
        agentLevel: this.form.agentLevel || "",
        parentAgentName: this.form.parentAgentName || "",
        activityOrder: {
          province: this.form.province,
          city: this.form.city,
          area: this.form.area,
          address: this.form.detailAddress,
          remark: this.form.remark || "",
        },
      };
      this.$U.showLoading(this);
      this.$H
        .post(this, this.$A.activityOrder.update, updateParams)
        .then((res) => {
          if (res?.data?.status === 200) {
            this.$message.success("保存成功");
            this.updateLocalFormData(updateParams);
          } else {
            this.$message.error(res?.data?.message || res?.data?.msg || "保存失败");
          }
        })
        .catch(() => {
          this.$message.error("保存失败");
        })
        .finally(() => {
          this.$U.hideLoading(this);
        });
    },
    updateLocalFormData(updatedData) {
      if (updatedData.agentName != null) this.form.agentName = updatedData.agentName;
      if (updatedData.agentPhone != null) this.form.agentPhone = updatedData.agentPhone;
      if (updatedData.agentLevel != null) this.form.agentLevel = updatedData.agentLevel;
      if (updatedData.parentAgentName != null) this.form.parentAgentName = updatedData.parentAgentName;
      if (updatedData.activityOrder) {
        const ao = updatedData.activityOrder;
        if (ao.province != null) this.form.province = ao.province;
        if (ao.city != null) this.form.city = ao.city;
        if (ao.area != null) this.form.area = ao.area;
        if (ao.address != null) this.form.detailAddress = ao.address;
        if (ao.remark != null) this.form.remark = ao.remark;
      }
    },
    updateAreaSelection(areaData) {
      this.form.province = areaData.province || "";
      this.form.city = areaData.city || "";
      this.form.area = areaData.area || "";
    },
  },
};
</script>

<style lang="less" scoped>
.bottom-actions {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.detail-container {
  width: 100%;
}

.detail-bread-crumb-div {
  margin-bottom: 10px;
}

.detail-card {
  background: #fff;
  border-radius: 6px;
}

::v-deep .detail-card {
  .el-tabs__header {
    margin: 0;
  }
}
</style>
